import { Region } from '@medusajs/medusa'

import axios from '@/core/axios'
import { WrapResponse } from '@/shared/types/axios'

export class RegionRepository {
    public async listRegions(): Promise<Region[]> {
        const { data } =
            await axios.get<WrapResponse<'regions', Region[]>>('/regions')
        return data.regions
    }
}
